import { all } from 'redux-saga/effects';

import authSagas from './authSagas';
import entitySagas from './entities';
import createProfileSagas from 'sagas/createProfileSagas';
import utilSagas from './util';
import settingSagas from './settingSagas';

export default function* rootSaga() {
  yield all([entitySagas(), authSagas(), createProfileSagas(), utilSagas(), settingSagas()]);
}
